import { meetNowButtonLabel } from '../constants/MeetNowStrings.locstring.json';
import openMeetNowWindow, { ScenarioName } from '../services/openMeetNowWindow';
import { CommandBarButton } from '@fluentui/react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import * as React from 'react';

const styles = require('./MeetNowCommandButton.scss');
const classNames = require('classnames');

export interface MeetNowCommandButtonProps {
    rootStyles?: string;
    iconStyles?: string;
    labelStyles?: string;
    scenario: ScenarioName;
}

export default function MeetNowCommandButton(props: MeetNowCommandButtonProps) {
    const onClickCallback = React.useCallback(() => openMeetNowWindow(props.scenario), [
        props.scenario,
    ]);
    return (
        <div className={classNames(styles.horizontalContainer, props.rootStyles)}>
            <CommandBarButton
                iconProps={{
                    iconName: ControlIcons.Video,
                }}
                text={loc(meetNowButtonLabel)}
                styles={{
                    root: styles.buttonRoot,
                    icon: props.iconStyles,
                    textContainer: classNames(styles.buttonTextContainer, props.labelStyles),
                }}
                onClick={onClickCallback}
            />
        </div>
    );
}
